<script lang="ts">
    import posthog from "posthog-js";
    import ColoredModal from "../colored/ColoredModal.svelte";
    import ColoredButton from "../colored/ColoredButton.svelte";
    import { P } from "flowbite-svelte";

    let {isOpen = $bindable(), close}: {
        isOpen: boolean,
        close: () => void
    } = $props();

    function acceptUpdate() {
        posthog.capture('update_accepted');
    }

</script>

<ColoredModal title="Update Available" autoclose bind:open={isOpen}>
    <P class="black:text-white frappe:text-ctp-subtext0">A new version of the app is available. Would you
        like to refresh the site to get the
        latest version?</P>

    {#snippet footer()}
        <ColoredButton href="/" class="me-2" onclick={acceptUpdate}>Yes</ColoredButton>
        <ColoredButton color="teal" onclick={close}>No</ColoredButton>
    {/snippet}
</ColoredModal>
